import { ValuationTypeEnumType } from '__generated__/graphql';

export default function valuationTypeToReadable(valuationType?: ValuationTypeEnumType | null): {
  label: string;
  color: string;
} {
  if (!valuationType) {
    return {
      label: 'Unknown',
      color: 'gray',
    };
  }

  switch (valuationType) {
    case ValuationTypeEnumType.PreMoney:
      return {
        label: 'Pre-Money',
        color: 'indigo',
      };
    case ValuationTypeEnumType.PostMoney:
      return {
        label: 'Post-Money',
        color: 'green',
      };
    default:
      return {
        label: valuationType,
        color: 'gray',
      };
  }
}
